/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import { ifAuthenticated } from '../routeValidation';

const NoveltiesDiscountList = () =>
  import(
    /* webpackChunkName: "list_discounts" */
    '@/views/NoveltiesAndPromotions/Discounts/Home.vue'
  );
const CashbackList = () =>
  import(
    /* webpackChunkName: "list_cashback" */
    '@/views/NoveltiesAndPromotions/Cashback/List.vue'
  );
const CashbackCreate = () =>
  import(
    /* webpackChunkName: "create_cashback" */
    '@/views/NoveltiesAndPromotions/Cashback/Create.vue'
  );

const CashbackUpdate = () =>
  import(
    /* webpackChunkName: "update_cashback" */
    '@/views/NoveltiesAndPromotions/Cashback/Update.vue'
  );

const NoveltiesDiscountNew = () =>
  import(
    /* webpackChunkName: "new_discounts" */
    '@/views/NoveltiesAndPromotions/Discounts/New.vue'
  );
const noveltiesAndPromotions = {
  path: '/',
  component: DashboardLayout,
  beforeEnter: ifAuthenticated,
  name: 'NoveltiesAndPRomotions',
  children: [
    {
      path: '/noveltiesAndPromotions/discounts',
      name: 'NoveltiesDiscountList',
      component: NoveltiesDiscountList,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/noveltiesAndPromotions/discounts/new',
      name: 'NoveltiesDiscountNew',
      component: NoveltiesDiscountNew,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/noveltiesAndPromotions/discounts/:discount_id/edit',
      name: 'NoveltiesDiscountEdit',
      component: NoveltiesDiscountNew,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/noveltiesAndPromotions/cashback',
      name: 'CashbackList',
      component: CashbackList,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/noveltiesAndPromotions/cashback/new',
      name: 'CashbackCreate',
      component: CashbackCreate,
      meta: {
        navbarType: 'light',
      },
    },
    {
      path: '/noveltiesAndPromotions/cashback/update/:id',
      name: 'CashbackUpdate',
      component: CashbackUpdate,
      meta: {
        navbarType: 'light',
      },
    }
  ],
};
export default noveltiesAndPromotions;
